import { Link } from 'react-router-dom'
import { Container, ImageContainer, TextContainer, Image, TitleContainer, ActionContainer, Title } from './styled'
import { useNotification } from 'lib/context/notification.context'
import { useNavigate } from 'react-router-dom'

import noImg from 'assets/images/no-image.png'
import { useTranslation } from 'react-i18next'
import { StrokedButton } from 'views/components/UI/Buttons'

interface IProps {
  image: string
  title: string
  link: string
  params?: any
  disabled?: boolean
  is360?: boolean
  isSpecialAdmin?: boolean
}

function CardTestType(props: IProps) {
  const { t } = useTranslation()
  const { image, title, link, params, disabled, isSpecialAdmin } = props
  const { getWarning } = useNotification()
  const navigate = useNavigate()
  const disabledColor = '#C2C2C2'

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault()
    if (isSpecialAdmin) {
      getWarning(
        'Recuerda que sólo los administradores lideres y administradores de plataforma pueden ver los detalles'
      )
      return
    }
    if (!link || disabled) {
      if (title === 'Betesa' || title === 'Betesa - Talentos naturales') {
        getWarning('No se ha interpretado o finalizado la prueba')
      }

      if (title === t('global.common.skillText')) {
        getWarning('El usuario no ha finalizado la prueba')
      }
      if (title === 'Evaluación 360°') {
        getWarning('No se ha finalizado la prueba')
      }
    } else {
      navigate(props.link, { state: params })
    }
  }

  return (
    <Container>
      <ImageContainer style={{ background: disabled ? disabledColor : '#ffffff' }}>
        {image ? <Image disabled={disabled} src={image} /> : <Image disabled={disabled} src={noImg} />}
      </ImageContainer>
      <TextContainer style={{ background: disabled ? disabledColor : '#FBFBFB' }}>
        <TitleContainer>
          <Title style={{ color: disabled ? 'gray' : 'black' }}>{title || 'Inserte titulo'}</Title>
        </TitleContainer>
        <ActionContainer>
          <Link to={props.link} state={{ ...params }} onClick={handleClick}>
            <StrokedButton
              disabled={disabled || isSpecialAdmin}
              style={{ width: 'fit-content', padding: '8px 16px', boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)' }}
            >
              Ver detalles
            </StrokedButton>
          </Link>
        </ActionContainer>
      </TextContainer>
    </Container>
  )
}

export default CardTestType
